import styled from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';

import { MAIN_TITLE_SIZE } from '../../constants';

const charityLogoWidth = '120px';

export const Header = styled.header`
  margin: ${layout.spacing.small};
  display: grid;
  align-items: center;
  grid-template-columns: ${charityLogoWidth} auto;
  grid-template-rows: auto auto auto;
  column-gap: ${layout.spacing.small};

  ${media.mediumUp`
    @supports (display:grid) {
      display: grid;
      align-items: flex-start;
      grid-template-columns: auto 1fr auto;
      grid-template-rows: auto 1fr;
    }
  `}
`;

export const Logo = styled.div`
  grid-area: 1 / 1 / 3 / 2;
  min-height: 0;

  ${media.smallOnly`
    grid-area: 1 / 1 / 2 / 2;
  `};
`;

export const Title = styled.h1`
  font-size: ${remCalc(MAIN_TITLE_SIZE)};
  grid-area: 1 / 2 / 2 / 2;
  min-height: 0;

  ${media.smallOnly`
    grid-area: 1 / 2 / 2 / 3;
  `};
`;

export const Description = styled.p`
  grid-area: 2 / 2 / 3 / 3;

  ${media.smallOnly`
    grid-area: 2 / 1 / 3 / 3;
  `};
`;

export const Charity = styled.div`
  display: flex;
  flex-direction: column;
  align-self: baseline;
  width: ${charityLogoWidth};
  margin-left: ${layout.spacing.small};
  align-items: center;
  grid-area: 1 / 3 / 4 / 4;

  ${media.smallOnly`
    grid-area: 3 / 1 / 4 / 3;
  `};

  ${media.smallOnly`
    margin: 0;
    margin-top: ${layout.spacing.small};
    width: auto;
    flex-direction: row;
  `}
`;

export const CharityLogo = styled.img`
  margin-bottom: ${layout.spacing.small};

  ${media.smallOnly`
    width: ${charityLogoWidth};
    margin-left: ${layout.spacing.xSmall};
    margin-bottom: 0;
  `};
`;
